module.exports = __webpack_public_path__ + "img/Kongespegelen_En_ridder_blir_badet.73861225.jpg";